var checkout = {
 	
 	current_step : $('.check-out-container').data('step')==="private-label"?1:2,
  	
  	api_route : '/orders',

	billing_address : 0,
	shipping_address : 0,

 	load_step : function(){

 		load_partial( $('.check-out-container .step[data-step="'+checkout.current_step+'"]') , function(){
 			
 			$('.check-out-container .step[data-step!="'+checkout.current_step+'"]').hide();
 			$('.check-out-container .step[data-step="'+checkout.current_step+'"]').show();

 			$('.cart-sidebar  .steps-list .steps-list-item').removeClass('active');
 			$('.cart-sidebar  .steps-list .steps-list-item[data-checkout-step="'+checkout.current_step+'"]').addClass('active');

 			$('.select-address').on('click',function(){
 				$(this).closest('.address-item').toggleClass('default-address');

 				if(checkout.current_step===2){
 					checkout.billing_address = $(this).closest('.address-item').data('id');
 				}

 				if(checkout.current_step===3){
 					checkout.shipping_address = $(this).closest('.address-item').data('id');
 				}


 				checkout.register_step(function(d){
					checkout.current_step++;
				    checkout.load_step();
				});
				return false;
 			});

 			if(checkout.current_step===4 && $('.cart.cart-sidebar').length>0){
 				$('.check-out-container .step').parent().removeClass('col-lg-8');
 				$('.cart.cart-sidebar').parent().hide();
 			}else{
 				$('.check-out-container .step').parent().addClass('col-lg-8');
 				$('.cart.cart-sidebar').parent().show();
 				 				
 			}

			$('.checkout-register-step').on('click' , function(){
				
				checkout.register_step(function(d){
					if(checkout.current_step ==4 ){

						if(typeof(d.redirect)!=='undefined'){
							window.location = d.redirect;
						}
						
					}else{
						checkout.current_step++;
						checkout.load_step();

					}
				});
				
				
				return false;
			});

			
		$('.previous-step').on('click' , function(){
			checkout.current_step--;
			checkout.load_step();
			return false;
		});

 		$('.steps-nav-item').on('click' , function(){
			var step  = $(this).data('checkout-step');
			checkout.current_step = step ;
			checkout.load_step();
			return false;
		});


			
 		});


		
 	},
 	get_step_data : function(){
 		var last_step = $('.step:last').data('step');

 		if( checkout.current_step == 1 ){
	 		return {
	 			step : 'private-label',
	 			notes:$('#checkout_step_0_form').serialize()
	 		}; 
 		}else if( checkout.current_step == 2 ){
	 		return {
	 			step : 'billing-address',
	 			billing_address_id : checkout.billing_address
	 		}; 
 		}else if(checkout.current_step == 3){
			return {
				step : 'shipping-address',
	 			shipping_address_id : checkout.shipping_address
	 		};
 		}else if(checkout.current_step == 4){
			return {
				step : 'place-order'
			};
 		}

 	},
 	register_step : function(cb){
		$.ajax({
			type: "POST", 
			url: checkout.api_route,
			data: checkout.get_step_data(),
			success:function(data){ 
				cb(data);
			},error:function(data){ 
				actionResponseModal(data.responseJSON.error,'error','.actions-block .save'); 

			}
		});
 	}
}